export default "__VITE_ASSET__DJu15Y97__"